var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-max",
      class: { "p-0": _vm.$ceres.isShopBuilder },
    },
    [
      _c("div", { staticClass: "position-relative" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-grow-1 position-relative clearable" },
          [
            _c("input", {
              staticClass: "search-input flex-grow-1",
              attrs: {
                type: "text",
                id: "query",
                name: "q",
                placeholder: "Wonach suchst Du?",
              },
            }),
            _vm._v(" "),
            _c("i", { staticClass: "clearable__clear" }, [_vm._v("×")]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.isSearchFocused
              ? [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.hasInitialInput || _vm.$ceres.isShopBuilder,
                          expression: "hasInitialInput || $ceres.isShopBuilder",
                        },
                      ],
                    },
                    [
                      _vm._t("autocomplete-suggestions", function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "autocomplete-suggestions shadow bg-white w-100",
                            },
                            [
                              _c("search-suggestion-item", {
                                attrs: {
                                  "show-images": _vm.showItemImages,
                                  "suggestion-type": "item",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "search-button",
        attrs: { type: "button", onclick: "buttonOnClick(this)" },
      },
      [
        _c("img", {
          attrs: {
            src: "https://cdn02.plentymarkets.com/xp4oxtd91bsc/frontend/Images/Header/Navigation/magnifier-white.png",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }